import ButtonGroupOption from '@atoms/ButtonGroupOption';
import { ChevronRightOutlined, SchoolOutlined } from '@mui/icons-material';
import { ButtonGroup, FormLabel, Stack } from '@mui/material';
import { DIVISION_LIMITATION } from '@type/db-types';

interface Props {
    onChange: (value: DIVISION_LIMITATION) => void;
    value: DIVISION_LIMITATION;
}

export default function DivisionLimitForm({ onChange, value }: Props) {
    return (
        <Stack flexDirection={'row'} justifyContent={'space-evenly'} alignItems={'center'}>
            <FormLabel>Limit By:</FormLabel>
            <ButtonGroup variant="outlined" aria-label="limit division by">
                <ButtonGroupOption
                    onClick={onChange.bind(null, DIVISION_LIMITATION.NONE)}
                    selected={value === DIVISION_LIMITATION.NONE}
                    variant={value === DIVISION_LIMITATION.NONE ? 'contained' : 'outlined'}
                >
                    None
                </ButtonGroupOption>
                <ButtonGroupOption
                    endIcon={
                        value === DIVISION_LIMITATION.AGE ? <ChevronRightOutlined /> : undefined
                    }
                    onClick={onChange.bind(null, DIVISION_LIMITATION.AGE)}
                    selected={value === DIVISION_LIMITATION.AGE}
                    variant={value === DIVISION_LIMITATION.AGE ? 'contained' : 'outlined'}
                >
                    Age
                </ButtonGroupOption>
                <ButtonGroupOption
                    endIcon={
                        value === DIVISION_LIMITATION.GRADE ? <ChevronRightOutlined /> : undefined
                    }
                    onClick={onChange.bind(null, DIVISION_LIMITATION.GRADE)}
                    selected={value === DIVISION_LIMITATION.GRADE}
                    startIcon={<SchoolOutlined />}
                    variant={value === DIVISION_LIMITATION.GRADE ? 'contained' : 'outlined'}
                >
                    Grade
                </ButtonGroupOption>
            </ButtonGroup>
        </Stack>
    );
}
